module.exports = __webpack_public_path__ + "static/media/Video_Allow_Instruction_11.86922ab2.jpg";